/* eslint-disable */
function StackingScroll ({
	selector = 'swiper-selector',
	loop = true,
	cubicBezier = 'ease-in-out',
	itemTranslates = [rem(-150), rem(150), rem(-240), rem(240)],
	itemScale = [
		'scale3d(.8, .8, 1)',
		'scale3d(.8, .8, 1)',
		'scale3d(.667, .667, 1)',
		'scale3d(.667, .667, 1)'
	],
	itemChange
}) {
	let x0, y0, hasmoved = 0, lock = 0, currentIndex = 0
	let css = [
		`-webkit-transition: -webkit-transform .3s ${cubicBezier}; z-index: 3; -webkit-transform: translate3d(0, 0, 10px) scale3d(1, 1, 1); visibility: visible;`,
		`-webkit-transition: -webkit-transform .3s ${cubicBezier}; z-index: 2; -webkit-transform: translate3d(${itemTranslates[0]}, 0, 6px) ${itemScale[0]}; visibility: visible;`,
		`-webkit-transition: -webkit-transform .3s ${cubicBezier}; z-index: 2; -webkit-transform: translate3d(${itemTranslates[1]}, 0, 6px) ${itemScale[1]}; visibility: visible;`,
		`-webkit-transition: -webkit-transform .3s ${cubicBezier}; z-index: 1; -webkit-transform: translate3d(${itemTranslates[2]}, 0, 2px) ${itemScale[2]}; visibility: visible;`,
		`-webkit-transition: -webkit-transform .3s ${cubicBezier}; z-index: 1; -webkit-transform: translate3d(${itemTranslates[3]}, 0, 2px) ${itemScale[3]}; visibility: visible;`
	]
	function touchstartHandle (e) {
		let touch = e.targetTouches[0]
		let x = touch.pageX
		let y = touch.pageY
		x0 = x
		y0 = y
		hasmoved = 0
		lock = 0
	}
	function touchmoveHandle (e) {
		if (lock) return
		var touch = e.targetTouches[0]
		let x = touch.pageX
		let y = touch.pageY
		let offsetX = x0 - x
		let offsetY = y0 - y
		// 阻止滚动
		hasmoved || (hasmoved = 1, Math.abs(offsetX) > Math.abs(offsetY) && e.preventDefault())
		if (offsetX <= -50) {
			// 向右
			lock = 1
			if (!loop && currentIndex > 0) this.queue.unshift(this.queue.pop())
			else if (loop) this.queue.unshift(this.queue.pop())
			swap('right')
			// indicator控制
			currentIndex--
			if (loop) {
				if (currentIndex < 0) currentIndex = this.item.length - 1
			} else {
				if (currentIndex <= 0) currentIndex = 0
			}
			// changeItem回调
			if (itemChange && typeof itemChange === 'function') itemChange(currentIndex)
		} else if (offsetX >= 50) {
			// 向左
			lock = 1
			if (!loop && currentIndex < this.item.length - 1) this.queue.push(this.queue.shift())
			else if (loop) this.queue.push(this.queue.shift())
			swap('left')
			// indicator控制
			currentIndex++
			if (loop) {
				if (currentIndex > this.item.length - 1) currentIndex = 0
			} else {
				if (currentIndex >= this.item.length - 1) currentIndex = this.item.length - 1
			}
			// changeItem回调
			if (itemChange && typeof itemChange === 'function') itemChange(currentIndex)
		} 
	}
	function swap (orientation) {
		let queue = [].concat(this.queue)
		let total = this.virtual.length // item 总数
		let last = total - 1 // 最后一个索引
		let collect = 0 // 提取数
		let virtual = new Array(total)
		let odd = 1
		// 提取前三个元素与后三个元素
		while (collect < 5 && queue.length > 0) {
      		// 做一个方向优化
			virtual[
				odd ? queue.shift() : queue.pop()
			] = css[
				collect == last && !odd && 'right' === orientation
					? ++collect
					: collect++
			]
			// 取反
			odd = !odd
		}
		// 对比一下数组 
		for (let i = 0; i < total; ++i) { 
			virtual[i] != this.virtual[i] && (
				this.virtual[i] = virtual[i],
				this.item[i].style.cssText = this.virtual[i] || 'visibility: hidden'
			)
		}
	}
	swap = swap.bind(this)

	function rem (px) {
		return px / 40 + 'rem'
	}
	// 索引列表，用于处理切换的序号队列
	this.queue = []
	this.init = function(list) {
		this.container = list
		this.container.style['-webkit-transform-style'] = 'preserve-3d'
		this.item = list.querySelectorAll('li')
		// 与 item 做对应的虚拟DOM
    	this.virtual = new Array(this.item.length)
    	for (let i = 0; i < this.item.length; ++i) { this.item[i].style.visibility = 'hidden' }
		for (let i = 0; i < this.item.length; ++i) this.queue[i] = i
    	// 初始排版
		swap('right')
		if(this.item.length <= 1) return
		this.container.addEventListener("touchstart", touchstartHandle)
		this.container.addEventListener("touchmove", touchmoveHandle.bind(this))
	}

	this.destory = function () {
		this.container.removeEventListener("touchstart", touchstartHandle)
		this.container.removeEventListener("touchmove", touchmoveHandle.bind(this))
	}

	// 默认 new 即初始化
	var list = document.querySelector(selector)
	list ? this.init(list) : console.error(selector + ' undefined')
}

export default StackingScroll